import React from 'react';

import { Navigate } from 'react-router-dom';
import Route from 'enum/route.enum';
import BaseWeatherComponent from 'components/weather/BaseWeatherComponent';
import { Container, ContentMiddleRowContent, ErrorContainer, ErrorText } from './styles';
import {
  WeatherCard,
  WeatherCityName,
  WeatherIconBox,
  WeatherTemp,
  WeatherDetailsSection,
  WeatherDetailRow,
  WeatherDetailLeft,
  WeatherDetailIcon,
  WeatherDetailLabel,
  WeatherDetailValue,
} from './components/WeatherCard/styles';
import LoadImage from 'components/common/loadImage/loadImage';
import { translate as t } from 'utils/i18n';
import HeaderBarComponent from './components/HeaderBar';
import humidityIcon from 'assets/images/humidity-white.svg';
import windIcon from 'assets/images/wind-white.svg';
import { ContentBody, ContentContainer, OuterContentContainer } from 'design-tokens/warwick/common';
import PageHeader from './components/PageHeader';

class weather extends BaseWeatherComponent {
  renderWeatherData() {
    return this.state.items.map(
      (item, i) =>
        item != null && (
          <WeatherCard key={i}>
            <WeatherCityName>{item.name}</WeatherCityName>
            <WeatherIconBox>
              <LoadImage
                image_url={'http://openweathermap.org/img/wn/' + item?.icon + '.png'}
                width={'80px'}
                height={'80px'}
              />
            </WeatherIconBox>
            <WeatherTemp>{Math.round(item.temp)}°</WeatherTemp>
            <WeatherDetailsSection>
              <WeatherDetailRow>
                <WeatherDetailLeft>
                  <WeatherDetailIcon src={humidityIcon} alt='' />
                  <WeatherDetailLabel>{t('Weather.humidity')}</WeatherDetailLabel>
                </WeatherDetailLeft>
                <WeatherDetailValue>{item.humidity}%</WeatherDetailValue>
              </WeatherDetailRow>
              <WeatherDetailRow>
                <WeatherDetailLeft>
                  <WeatherDetailIcon src={windIcon} alt='' />
                  <WeatherDetailLabel>{t('Weather.wind')}</WeatherDetailLabel>
                </WeatherDetailLeft>
                <WeatherDetailValue>{(item.windSpeed * 3.6).toFixed(1)} km/h</WeatherDetailValue>
              </WeatherDetailRow>
            </WeatherDetailsSection>
          </WeatherCard>
        )
    );
  }

  render() {
    if (this.state.redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }
    return (
      <Container>
        <HeaderBarComponent></HeaderBarComponent>
        <OuterContentContainer>
          <ContentContainer>
            <PageHeader
              title={t('Weather.weather')}
              onBack={() => this.setState({ redirectBack: true })}
              autoFocus={true}
            ></PageHeader>
            <ContentBody>
              {this.state.items?.length ? (
                <ContentMiddleRowContent>{this.renderWeatherData()}</ContentMiddleRowContent>
              ) : !this.state.loading ? (
                <ErrorContainer>
                  <ErrorText>{t('Weather.weather_error')}</ErrorText>
                </ErrorContainer>
              ) : null}
            </ContentBody>
          </ContentContainer>
        </OuterContentContainer>
      </Container>
    );
  }
}

export default weather;
